// src/router/AuthGuard.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../store/helpers';

const AuthGuard = () => {
  const token = useAppSelector(state => state.auth.token);
  const user = useAppSelector(state => state.auth.user);
  const activationStatus = user?.isActivated ?? (user as { activated?: boolean } | null)?.activated;

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (activationStatus === false) {
    return <Navigate to="/activation" replace />;
  }

  return <Outlet />;
};

export default AuthGuard;
